import { classNames } from "../../../utils/classNames";
import Spinner from "../Spinner";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
const Button = (props: any) => {
  const {
    type = "submit",
    label,
    isLoading = false,
    disabled = false,
    ...other
  } = props;
  return (
    <>
      <button
        type={type}
        disabled={isLoading || disabled}
        className={classNames(
          isLoading || disabled ? tw`bg-gray-500` : tw`bg-primary`,
          tw`w-full text-white py-2 rounded my-2 focus:outline-none`
        )}
        {...other}
      >
        {isLoading ? <Spinner /> : label}
      </button>
    </>
  );
};

export default Button;
